(function(){
  function ready(fn){
    if(document.readyState !== 'loading'){
      fn();
    }else{
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function(){
    var headerWrapper = document.querySelector('.header-wrapper');
    var setHeaderState = function(){
      if(!headerWrapper){ return; }
      if(window.scrollY > 40){
        headerWrapper.classList.add('is-scrolled');
      }else{
        headerWrapper.classList.remove('is-scrolled');
      }
    };
    setHeaderState();
    window.addEventListener('scroll', setHeaderState, { passive: true });
  });

  var loaderStart = Date.now();
  window.addEventListener('load', function(){
    var loader = document.getElementById('site-loader');
    if(!loader){ return; }
    var elapsed = Date.now() - loaderStart;
    var wait = Math.max(700 - elapsed, 0);
    setTimeout(function(){
      loader.classList.add('is-hidden');
      setTimeout(function(){
        if(loader && loader.parentNode){
          loader.parentNode.removeChild(loader);
        }
      }, 650);
    }, wait);
  });
})();
